import App from 'src/App.jsx';
import Root from 'src/Root';

// Hotel search results route: /c/:organizationSlug/hotels?...
// Same render as sibling routes — Vike's filesystem routing requires a
// +Page in this directory to claim the URL pattern, but the actual
// page within is resolved by react-router inside <App />. The OG
// metadata is what differs (see +title.ts / +description.ts /
// +image.ts / +Head.tsx siblings).
export default function Page() {
   return (
      <Root>
         <App />
      </Root>
   );
}
